import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class BookerAuthorize extends Component {
  constructor() {
    super();

    this.state = {
      errors: {},
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  onSubmit() {
    const { configureData } = this.props;
    const { isBrandLocation, selectedLocation, referralEmail } = configureData;
    const data = {
      ...(!isBrandLocation && {location_id:selectedLocation}),
      referral_email:referralEmail
    }
    this.props.postZenotiAuthorize(data);
    //console.log('configureData',);
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  render() {
    const { softwares, onBack, business } = this.props;
    console.log('Props', this.props);
    const business_name =  business.info.BUSINESS_NAME? business.info.BUSINESS_NAME: softwares.info.STUDIO_NAME;
    return (
      <div className="authorize-access">
        <form className="authorize-access__form">
          <section className="authorize-access__sw-details">
            <p className="authorize-access__heading">
            Verify your business details and then authorize
            </p>
            {business && business.info &&
              <div>
                <div>{business_name}</div>
                <div>{business.info.EMAIL}</div>
                {/* <div>{business.info.}</div> */}
              </div>
            }
          </section>
        </form>
        <div className="authorize-access__actions">
          <button className="btn btn--secondary btn--lg" type="button" onClick={onBack}>
            Previous
          </button>
          <button
            className="btn btn--primary btn--lg"
            onClick={this.onSubmit}
            disabled={softwares.isSavingStaffCredentials}
          >
            {!softwares.isSavingStaffCredentials ? 'Authorize TrueLark' : 'Saving...'}
          </button>
        </div>
      </div>
    );
  }
}

BookerAuthorize.propTypes = {
  onBack: PropTypes.func.isRequired,
  postBookingSoftwareRequest: PropTypes.func.isRequired,
  softwares: PropTypes.shape().isRequired,
  business: PropTypes.shape().isRequired,
};
